module.exports = __webpack_public_path__ + "static/ui5-083318041ddbcc66528702b1e1c8197a.mp3";